<template>
  <div class="c_quote_slider__content__wrapper" :data-component-theme="theme || 'white'">
    <div class="c_quote_slider__quote_icon" role="presentation">
      <IconSVG handle="quote" />
    </div>
    <div class="c_quote_slider__content">
      <div class="c_quote_slider__content__text">
        <blockquote
          v-if="slide.quote"
          class="c_quote_slider__content__text__quote c_2022--blockquote_schnyder"
          v-html="'&quot;' + slide.quote + '&quot;'"
        ></blockquote>
        <div class="c_quote_slider__attribution">
          <MediaImage
            v-if="slide.authorImage.length"
            :sources="[{ src: slide.authorImage[0].aspectRatio11.srcWebp }]"
          />
          <div class="c_quote_slider__attribution__text">
            <cite
              aria-label="Quote author"
              v-if="slide.quoteAuthor"
              class="c_quote_slider__content--name c_text--graphik_regular c_2022--body"
              v-html="slide.quoteAuthor"
            ></cite
            ><span v-if="slide.descriptor">, </span
            ><cite
              aria-label="Quote author descriptor"
              v-if="slide.descriptor"
              v-html="slide.descriptor"
              class="c_quote_slider__content--descriptor c_text--graphik_regular c_2022--body"
            ></cite
            ><span v-if="slide.workplace">, </span
            ><cite
              aria-label="Quote author workplace"
              v-if="slide.workplace"
              v-html="slide.workplace"
              class="c_quote_slider__content--workplace c_text--graphik_regular c_2022--body"
            ></cite>
          </div>
        </div>
        <div class="c_quote_slider__content__text__link" v-if="slide.button?.url">
          <a
            class="c_quote_slider__content__text__link__entry c_text--graphik_semibold c_2022--body"
            :href="slide.button.url"
            :aria-label="slide.button.ariaLabel"
            :target="slide.button.target"
          >
            <span>{{ slide.button.customText || $t('Read The Story') }}</span>
            <IconSVG handle="chevron_right_v2" width="16" height="16" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import MediaImage from 'Components/image/MediaImage.vue';
import IconSVG from 'Components/icon_svg/IconSVG.vue';

export default defineComponent({
  name: 'Quote',
  components: {
    MediaImage,
    IconSVG,
  },
  props: {
    slide: Object,
    theme: String,
    mediaType: String,
  },
});
</script>

<style lang="scss">
.c_quote_slider__content__wrapper {
  --quote-svg-color: var(--color-gray_201);
  --quote-icon-color: var(--color-red);

  &[data-component-theme='white'] {
    --quote-svg-color: var(--color-gray_221);
    --quote-icon-color: var(--color-red);
  }
  &[data-component-theme='black'] {
    --quote-svg-color: var(--color-gray_86);
    --quote-icon-color: var(--color-yellow);
  }
  &[data-component-theme='yellow'] {
    --quote-svg-color: var(--color-yellow-06);
    --quote-icon-color: var(--color-black);
  }
  &[data-component-theme='lightGray'] {
    --quote-svg-color: var(--color-gray_191);
    --quote-icon-color: var(--color-red);
  }
  &[data-component-theme='background'] {
    --quote-svg-color: var(--color-gray_112);
    --quote-icon-color: var(--color-yellow);
    color: white
  }
}
.c_quote_slider_2022 {
  .c_quote_slider {
    $self: &;
    @at-root #{$self}__content {
      $content: &;
      display: flex;
      flex-flow: column nowrap;
      width: 100%;
      @include mq($mq_sm_to_md) {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: space-between;
      }
      @at-root #{&}--background {
        color: $color_white;
      }
      @at-root #{&}__wrapper {
        position: relative;
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
        justify-content: center;
        height: 100%;
        padding: 0;
        @include mq($mq_sm_to_md) {
          padding: 0 px_to_rem(40);
        }
        @include mq($mq_sm_to_md) {
          justify-content: center;
        }
      }

      @at-root #{&}__text {
        flex: 0 1 auto;
        order: 2;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2rem;
        @include mq($mq_sm_to_md) {
          order: 1;
        }

        @at-root #{&}__quote {
          @include font('schnyder_wide_m_light');
          font-weight: bold;
          max-width: 800px;
        }
        @at-root #{&}__link__entry {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          text-underline-offset: 1px;
          transition: all 0.3s;
          color: var(--quote-icon-color);
          &:hover {
            text-decoration: underline;
            text-underline-offset: 4px;
          }
        }
      }
      @at-root #{&}--name {
        @include font('graphik_semibold');
      }
      @at-root #{&}--descriptor {
        @include font('graphik_regular_italic');
      }
      @at-root #{&}--workplace {
        @include font('graphik_medium_italic');
      }
    }
    @at-root #{$self}__attribution {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      align-items: center;
      justify-content: center;
      & > span {
        flex-shrink: 0;
      }
      img {
        width: px_to_rem(50);
        height: px_to_rem(50);
        border-radius: 50%;
        overflow: hidden;
      }
      figure {
        align-self: center;
        flex-shrink: 0;
      }
    }
    &__quote_icon {
      margin: 0 0 40px 0;
      color: var(--quote-svg-color);
    }
  }
}
</style>
